/* eslint-disable react-hooks/exhaustive-deps */
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Fragment, useEffect, useState } from "react";

const WORDS = [
  "one",
  "two",
  "three",
  "four",
  "five",
  "six",
  "seven",
  "eight",
  "nine",
  "ten",
];

// 0 = dropdown , 1 = input
const QUESTIONS = [
  {
    question: "What Industry is your business in?",
    type: 0,
    options: [
      { id: 0, name: "Business Services", multiplier: 4 },
      { id: 1, name: "Consumer Services", multiplier: 4 },
      { id: 2, name: "Education Services", multiplier: 4 },
      { id: 3, name: "Facility Services", multiplier: 4 },
      { id: 4, name: "Government Services", multiplier: 4 },
      { id: 5, name: "Financial Services", multiplier: 4 },
      { id: 6, name: "Healthcare Services", multiplier: 4 },
      { id: 7, name: "Industrial Services", multiplier: 4 },
      { id: 8, name: "IT Services", multiplier: 4 },
      { id: 9, name: "Engineering & Construction", multiplier: 3 },
      { id: 10, name: "Manufacturing", multiplier: 3 },
      { id: 11, name: "Transportation & Logistics", multiplier: 4 },
      { id: 12, name: "Other", multiplier: 4 },
    ],
  },
  {
    question: "How many years has your business been active?",
    type: 1,
    options: [],
  },
  {
    question:
      "What is your company's annual EBITDA (bottom line profits, NOT revenue)?",
    type: 2,
    options: [],
  },
  {
    question: "What is the trend of your annual profits?",
    type: 0,
    options: [
      { id: 13, name: "Declining rapidly", multiplier: -2 },
      { id: 14, name: "Declining slowly", multiplier: -1 },
      { id: 15, name: "Stable", multiplier: 0 },
      { id: 16, name: "Growing slowly", multiplier: 0 },
      { id: 17, name: "Growing rapidly", multiplier: 0.5 },
    ],
  },
  {
    question: "How many customers account for 50% of the company's sales?",
    type: 1,
    options: [],
  },
  {
    question: "What is the EBITDA (or operating income) margin %?",
    type: 0,
    options: [
      { id: 18, name: "0-4%", multiplier: -2 },
      { id: 19, name: "5-9%", multiplier: -1 },
      { id: 20, name: "10-14%", multiplier: 0 },
      { id: 21, name: "15-19%", multiplier: 0.5 },
      { id: 22, name: "20%+", multiplier: 1 },
    ],
  },
  {
    question: "How would you assess the strength of non-owner management?",
    type: 0,
    options: [
      { id: 23, name: "There are no non-owner managers", multiplier: -2 },
      { id: 24, name: "Needs Improvement", multiplier: -1 },
      { id: 25, name: "Stable", multiplier: 0 },
      { id: 26, name: "Above average", multiplier: 0 },
      { id: 27, name: "Strong", multiplier: 0.5 },
    ],
  },
  {
    question: "What does the business spend annually in capital expenditures?",
    type: 2,
    options: [],
  },
  {
    question:
      "Does your business have any surplus cash or investments? If so, how much are they worth?",
    type: 2,
    options: [],
  },
  {
    question: "Does your business have any debts? If so, how much for?",
    type: 2,
    options: [],
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Select({ title, options, selected, setSelected }) {
  return (
    <Listbox value={selected} onChange={setSelected}>
      {({ open }) => (
        <div>
          <Listbox.Label className="block text-xl font-medium leading-6 text-gray-900">
            {title}
          </Listbox.Label>
          <div className="relative mt-2">
            <Listbox.Button className="relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-[#2e908b] sm:text-md sm:leading-6">
              <span className="block truncate">{selected.name}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Listbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Listbox.Options className="absolute z-10 mt-1 max-h-52 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-md">
                {options.map((option) => (
                  <Listbox.Option
                    key={option.id}
                    className={({ active }) =>
                      classNames(
                        active ? "bg-[#2e908b] text-white" : "text-gray-900",
                        "relative cursor-default select-none py-2 pl-3 pr-9"
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? "font-semibold" : "font-normal",
                            "block truncate"
                          )}
                        >
                          {option.name}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active ? "text-white" : "text-[#2e908b]",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        </div>
      )}
    </Listbox>
  );
}

function CurrencyInput({ name, id, value, handleChange }) {
  return (
    <div className="relative mt-2 rounded-md shadow-sm">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
        <span className="text-gray-500 sm:text-sm">$</span>
      </div>
      <input
        type="text"
        autoFocus
        name={name}
        id={id}
        value={value}
        onChange={handleChange}
        className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#2e908b] sm:text-lg sm:leading-6"
        aria-describedby="price-currency"
      />
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <span className="text-gray-500 sm:text-sm" id="price-currency">
          USD
        </span>
      </div>
    </div>
  );
}

function LabelWithInput({
  label,
  name,
  id,
  value,
  handleChange,
  isCurrencyInput,
}) {
  return (
    <div>
      <label
        htmlFor={label}
        className="block text-xl font-medium leading-6 text-gray-900 capitalize"
      >
        {label}
      </label>
      {isCurrencyInput ? (
        <CurrencyInput
          name={name}
          id={id}
          value={value}
          handleChange={handleChange}
        />
      ) : (
        <div className="mt-2">
          <input
            type="text"
            autoFocus
            name={name}
            id={id}
            value={value}
            onChange={handleChange}
            className="px-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#2e908b] sm:text-lg sm:leading-6"
          />
        </div>
      )}
    </div>
  );
}

function Question({
  isSelect,
  isCurrencyInput,
  title,
  options,
  selected,
  handleSelect,
  step,
  value,
  handleChange,
}) {
  if (isSelect) {
    return (
      <Select
        title={title}
        options={options}
        selected={selected}
        setSelected={handleSelect}
      />
    );
  }

  return (
    <LabelWithInput
      isCurrencyInput={isCurrencyInput}
      label={title}
      name={step}
      id={step}
      value={value}
      handleChange={handleChange}
    />
  );
}

function App() {
  const [step, setStep] = useState(0);

  const [answers, setAnswers] = useState({
    0: { answer: QUESTIONS[0].options[0] },
    1: { answer: "0" },
    2: { answer: "0" },
    3: { answer: QUESTIONS[3].options[0] },
    4: { answer: "0" },
    5: { answer: QUESTIONS[5].options[0] },
    6: { answer: QUESTIONS[6].options[0] },
    7: { answer: "0" },
    8: { answer: "0" },
    9: { answer: "0" },
  });

  const [equityValue, setEquityValue] = useState(0);

  function handleSelect(selection) {
    setAnswers((prev) => ({
      ...prev,
      [step]: { answer: selection },
    }));
  }

  function handleInputChange(e) {
    let toCheck;
    //basic validation
    const needsNumberValidation =
      step === 1 || step === 2 || step === 4 || step >= 7;
    if (needsNumberValidation) {
      toCheck = e.target.value.replaceAll(",", "");
      if (isNaN(Number(toCheck))) {
        return;
      }
    }

    const isCurrency = step === 2 || step >= 7;
    if (isCurrency) {
      setAnswers((prev) => ({
        ...prev,
        [step]: {
          answer: Number(toCheck).toLocaleString(),
        },
      }));
    } else {
      setAnswers((prev) => ({
        ...prev,
        [step]: { answer: e.target.value },
      }));
    }
  }

  function goBackward() {
    setStep((s) => s - 1);
  }

  function goForward() {
    setStep((s) => s + 1);
  }

  useEffect(() => {
    if (step === 10) {
      let multiplierSums = 0;

      const length = Object.keys(answers).length;

      for (let i = 0; i < length; i++) {
        if (typeof answers[i].answer === "object") {
          if (answers[i].answer.multiplier > 0) {
            multiplierSums += answers[i].answer.multiplier;
          }

          if (answers[i].answer.multiplier < 0) {
            multiplierSums -= answers[i].answer.multiplier;
          }
        }

        if (i === 1) {
          const value = Number(answers[i].answer.replaceAll(",", ""));
          if (value <= 3) {
            multiplierSums -= 0.5;
          }

          if (value >= 10) {
            multiplierSums += 0.25;
          }
        }

        if (i === 2) {
          const value = Number(answers[i].answer.replaceAll(",", ""));
          if (value <= 500_000) {
            multiplierSums -= 2;
          }

          if (value > 500_000 && value <= 1_000_000) {
            multiplierSums -= 1;
          }

          if (value > 1_000_000 && value <= 1_500_000) {
            multiplierSums -= 0.5;
          }

          if (value > 3_000_000 && value <= 4_000_000) {
            multiplierSums += 0.5;
          }

          if (value > 4_000_000 && value <= 5_000_000) {
            multiplierSums += 0.75;
          }

          if (value > 5_000_000 && value <= 10_000_000) {
            multiplierSums += 1;
          }

          if (value > 10_000_000) {
            multiplierSums += 2;
          }
        }

        if (i === 4) {
          const value = Number(answers[i].answer.replaceAll(",", ""));
          if (value <= 1) {
            multiplierSums -= 2;
          }

          if (value >= 1 && value <= 3) {
            multiplierSums -= 1;
          }

          if (value >= 10) {
            multiplierSums += 0.5;
          }
        }
      }

      const enterpriseValue =
        multiplierSums *
        (Number(answers[2].answer.replaceAll(",", "")) -
          Number(answers[7].answer.replaceAll(",", "")));

      setEquityValue(
        enterpriseValue +
          Number(answers[8].answer.replaceAll(",", "")) -
          Number(answers[9].answer.replaceAll(",", ""))
      );
    }
  }, [step]);

  return (
    <div className="h-screen bg-[#2e908b] flex justify-center items-center">
      <div
        className={`bg-white rounded-3xl md:w-8/12 w-10/12 p-8 shadow-xl flex flex-col justify-between
${step !== 10 ? "h-96" : "h-64"}`}
      >
        <div className="space-y-6">
          <h2 className="text-[#2e908b] text-xl font-extrabold capitalize">
            {step !== 10
              ? `question ${WORDS[step]}`
              : "Your value is estimated to be"}
          </h2>

          {step !== 10 ? (
            <Question
              isSelect={QUESTIONS[step].type === 0}
              isCurrencyInput={QUESTIONS[step].type === 2}
              title={QUESTIONS[step].question}
              options={QUESTIONS[step].options}
              selected={answers[step].answer}
              handleSelect={handleSelect}
              step={step}
              value={answers[step].answer}
              handleChange={handleInputChange}
            />
          ) : (
            <p className="text-3xl font-extrabold text-center">
              ${equityValue.toLocaleString()}
            </p>
          )}
        </div>

        <div className="w-full flex space-x-2">
          {step !== 10 && step > 0 ? (
            <button
              onClick={goBackward}
              className="rounded px-2 py-3 text-gray-900 text-xl tracking-wider w-1/2 border border-[#2e908b]"
            >
              Go Back
            </button>
          ) : null}
          {step !== 10 && (
            <button
              disabled={step === 10 || answers[step].answer === ""}
              onClick={goForward}
              className={`bg-[#2e908b] rounded px-2 py-3 text-white text-xl tracking-wider ${
                step === 0 ? "w-full" : "w-1/2"
              }`}
            >
              Continue
            </button>
          )}
          {step === 10 && (
            <button
              onClick={() => setStep(0)}
              className={`bg-[#2e908b] rounded px-2 py-3 text-white text-xl tracking-wider w-full`}
            >
              Re-calculate
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
